module.exports = __webpack_public_path__ + "img/icon17.e872c7db.png";